<template>
  <div class="badge-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('badge_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-police-badge</v-icon>{{ $t('menu.user.badge') }}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <BadgeFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />
          <v-container grid-list-xl fluid>
            <v-row>
              <v-col cols="12" sm="3" md="3" v-for="item in items" :key="item.id" >
                <v-card class="secondary">
                  <v-img
                    height="250"
                    class="white--text align-end grey darken-4"
                    lazy-src="@/assets/imagenotfound.png"
                    :key="componentKey"
                    contain
                    @click="showHandler(item)"
                    :src="getImageUrlByObject(item)"
                  >

                   </v-img>
                   <v-card-actions>
                     <v-card-title v-text="item.name"></v-card-title>
                   </v-card-actions>
                 </v-card>
              </v-col>
            </v-row>
          </v-container>

        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import BadgeFilterForm from '../../components/badge/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';
import FileMixin from '../../mixins/FileMixin';

export default {
  name: 'BadgeList',
  servicePrefix: 'Badge',
  mixins: [ListMixin,AccessMixin,FileMixin],
  components: {
    Toolbar,
    BadgeFilterForm,
    DataFilter
  },
  data() {
    return {
    //  filter: '250x250',

      options: {sortBy : ['name'], sortDesc : [false]}
    };
  },
  mounted() {
      this.getPage({'itemsPerPage': '100','order[id]': 'desc'})
  },
  computed: {
    ...mapGetters('badge', {
      items: 'list'
    }),
    ...mapFields('badge', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('badge', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
